import { render } from "./StabilityGaugeChart.vue?vue&type=template&id=0f0643fe&scoped=true"
import script from "./StabilityGaugeChart.vue?vue&type=script&lang=ts"
export * from "./StabilityGaugeChart.vue?vue&type=script&lang=ts"

import "./StabilityGaugeChart.vue?vue&type=style&index=0&id=0f0643fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f0643fe"

export default script